module.exports = __webpack_public_path__ + "static/media/long-07.6e6ed1d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pitch-deck/long/long-07.png
// module id = 2131
// module chunks = 0